import React from 'react';
import './SkeletonLoader.css';

const Skeleton = ({ width, height, style, className, count = 1 }) => {
  const elements = [];
  for (let i = 0; i < count; i++) {
    elements.push(
      <div
        key={i}
        className={`skeleton-wave ${className || ''}`}
        style={{
          width: width,
          height: height || '20px',
          marginBottom: count > 1 && i < count - 1 ? '10px' : 0,
          ...style
        }}
      ></div>
    );
  }
  
  return (
    <>
      {elements}
    </>
  );
};

export default Skeleton;
